import React from 'react'

class Footer extends React.Component {
  render() {
    return (
      <div id="footer">
        <div className="inner">
          <ul className="icons">
            <li>
              <a
                href="https://www.linkedin.com/in/oakcooper"
                target="_blank"
                rel="noopener noreferrer"
                className="icon"
              >
                <i className="fab fa-linkedin fa-2x" />
                <span className="label">Linked In</span>
              </a>
            </li>
            <li>
              <a
                href="https://www.github.com/oak-wildwood"
                target="_blank"
                rel="noopener noreferrer"
                className="icon"
              >
                <i className="fab fa-github fa-2x" />
                <span className="label">Github</span>
              </a>
            </li>
          </ul>
          <ul className="copyright">
            <li>&copy;{new Date().getFullYear()} - Oak Cooper</li>
          </ul>
        </div>
      </div>
    )
  }
}

export default Footer
